import { ArticleContentType } from '@/types/schema';

class ArticleEntity {
  static id = (article?: ArticleContentType) => article?.id ?? '';
  // Static property 'name' conflicts with built-in property 'Function.name' :(
  static getName = (article?: ArticleContentType) => article?.name ?? '';

  static rootBlockId = (article?: ArticleContentType) =>
    (article as ArticleContentType & { requestedRootBlockId?: string })?.requestedRootBlockId ??
    article?.rootBlockId!;

  static defaultGroupId = (article?: ArticleContentType) => article?.defaultGroupId ?? '';

  static userPermissions = (article?: ArticleContentType) => article?.userPermissions ?? [];

  static cover = (article?: ArticleContentType) => article?.cover;

  static sharedSpace = (article?: ArticleContentType) => article?.sharedSpace ?? [];
  static applicableRoles = (article?: ArticleContentType) => article?.applicableRoles ?? [];

  static commentChannelId = (article?: ArticleContentType) => article?.creatorCommentChannel?.id;
}

export default ArticleEntity;
